module.exports = __webpack_public_path__ + "received-benefit.svg?467863b7fc5c5d0cb0a7ae7f27245f87";